import _ from 'lodash'
import axios from 'axios'

export const _Sites = {
  namespaced: true,
  state: {
    /**
     * Liste des licences
     * @type {Array}
     */
    sites: [],
    siteSelected: null,
    mapping: []
  },
  getters: {
    GET_SITE_BY_KEY: state => key => {
      return _.find(state.sites, {'LIC_KEY': key})
    },
    GET_SITE_BY_ID: state => id => {
      return _.find(state.sites, {'LIC_ID': id})
    },
    /**
     * Indique qu'au moins un motif est associé tous sites confondus
     */
    HAS_ONE_MOTIF: state => {
      return state.sites.filter(s => s.motifs && s.motifs.length > 0).length > 0
    },
    AUTORIZED_AGENTS: state => ({agentsArray, siteID, myID}) => {
      if (!state.mapping.length && !agentsArray.length) return []
      // uniquement les agent autoriser pour le site du chat client
      let listAgentsSite = state.mapping[siteID][0].LIC_USR_LIST
      // tous les agents
      let idAllAgents = listAgentsSite.map(agent => agent[0])
      // tous les agents sans moi
      let idAgents = idAllAgents.filter(agent => agent !== myID)
      // uniquement les agents autoriser à chater sur ce site
      return agentsArray.filter(agent => idAgents.findIndex(a => a === agent[2]) !== -1)
    },
    /**
     * Indique qu'au moins un tunnel est associé tous sites confondus
     */
    HAS_ONE_FUNNEL: state => {
      return state.sites.filter(s => s.LIC_IS_FUNNEL === '1').length > 0
    },
    /**
     * Indique qu'au moins un C2C est actif sur au moins un site
     */
    HAS_CALLBACK_ACTIVATED: state => {
      return state.sites.filter(s => s.LIC_CALLBACK_ACTIVATED === '1').length > 0
    },
    /**
     * Indique qu'au moins un C2C est actif sur au moins un site
     */
    HAS_RECALL_ACTIVATED: state => {
      return state.sites.filter(s => s.LIC_RECALL_ACTIVATED === '1').length > 0
    },
    /**
     * Indique qu'au moins un bot est actif sur au moins un site
     */
    HAS_BOT_ACTIVATED: state => {
      return state.sites.filter(s => s.LIC_BOT_ACTIVATED === '1').length > 0
    }
  },
  mutations: {
    INIT (state) {
      state.sites = []
      state.siteSelected = null
      state.mapping = []
    },

    ADD_SITE (state, site) {
      state.sites.push(site)
    },

    UPDATE_SITE_SETTINGS (state, site) {
      let idx = _.findIndex(state.sites, {'LIC_ID': site.LIC_ID})
      state.sites.splice(idx, 1, site)
    },

    UPDATE_SITE_SELECTED (state, site) {
      state.siteSelected = _.clone(site)
    },

    SET_MAPPING (state, mapping) {
      state.mapping = _.cloneDeep(mapping)
    }
  },

  actions: {
    /**
     * Récupère les sites en BDD
     * formate le résultat et le stock dans le store
     */
    GET ({ commit, state, getters }) {
      // Reset des sites
      commit('INIT')
      return new Promise((resolve, reject) => {
        // requête
        axios.get('get/sites.php')
        .then(response => {
          let sites = response.data
          _.each(sites, (site, id) => {
            try {
              site[0].DSK_CUSTOM_LEAD_FORM = JSON.parse(site[0].DSK_CUSTOM_LEAD_FORM)
            } catch (e) {
            }
            commit('ADD_SITE', site[0])
          })
          if (state.sites[0]) {
            commit('UPDATE_SITE_SELECTED', state.sites[0])
          }
          resolve(state)
        })
        .catch(e => {
          reject(e)
        })
      })
    },

    /**
     * Récupère le mapping agent/site
     */
    GET_MAPPING ({ commit, state, getters }) {
      return new Promise((resolve, reject) => {
        // requête
        axios.get('get/mapping.php')
        .then(response => {
          commit('SET_MAPPING', response.data)
          resolve(response.data)
        })
        .catch(e => {
          reject(e)
        })
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/sites.js